import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';

@Component({
  selector: 'app-modal-employee-job',
  templateUrl: './modal-employee-job.component.html',
  styleUrls: ['./modal-employee-job.component.css']
})
export class ModalEmployeeJobComponent implements OnInit {
  @Input() position:CatEmployeeJobModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus=1;

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private employeeJobService:CatEmployeeJobService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive=()=> this.position.activeId=!this.position.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.position.description=this.position.description.toUpperCase();
      this.employeeJobService.save(this.position)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('El puesto se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar el puesto.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.position.description || this.position.description.trim()==='';
}
